<svelte:options accessors />

<script context="module" lang="ts">
	export let count = 0;
</script>

<script lang="ts">
	import { onMount } from 'svelte';

	import FormGroup from '../sub_components/FormGroup.svelte';
	import TextInputSub from './TextInputSub.svelte';
	import type { Component, MultiText } from '@prisma/client';

	export const InstanceID = count;
	count += 1;
	export let Config: MultiText & Component;
	export let Values: string[] = [];
	export let Valid = false;
	let inputComps: TextInputSub[] = new Array<TextInputSub>(Config.MaxEntries);
	let OutlineEl: HTMLElement[] = new Array<HTMLElement>(Config.MaxEntries);
	$: curEntries = Values.length;

	if (Config.Required) {
		let newVals = [];
		for (let i = 0; i < Config.MinEntries; i++) {
			newVals.push('');
		}
		Values = Values.concat(newVals);
	} else {
		Values = [...Values, ''];
	}
	onMount(() => {
		if (!Config.Required && Config.MinEntries > 0) {
			alert(Config.Title + ' has an error: MinEntries must be 0 if Required is false');
		}
	});
	function addInput() {
		Values = [...Values, ''];
		enableOutline(Values.length - 1);
		//focus on the new input that is saved to inputComps
		setTimeout(() => {
			inputComps[Values.length - 1].focus();
		}, 50);
	}
	function removeInput(index: number) {
		Values.splice(index, 1);
		Values = Values;
	}
	export async function validate() {
		let valid = true;
		for (let i = 0; i < curEntries; i++) {
			let iValid = await inputComps[i].validate();
			if (iValid == false) {
				valid = false;
			}
		}
		Valid = valid;
		return Valid;
	}
	export function appendData(formData: FormData) {
		let combinedStr = '';
		for (let i = 0; i < curEntries; i++) {
			combinedStr += inputComps[i].Value + '|';
		}
		//remove last '|'
		combinedStr = combinedStr.slice(0, -1);
		formData.append(Config.DBCol, combinedStr);
	}

	export async function focus() {
		for (let i = 0; i < curEntries; i++) {
			if (!(await inputComps[i].validate())) {
				inputComps[i].focus();
				return;
			}
		}
		inputComps[0].focus();
	}
	// /^(http(s):\/\/.)[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$/
</script>

<FormGroup {Config}>
	<div class="col">
		{#if Config.Title}
			<div class="comp-title">{Config.Title}</div>
		{/if}
		{#each Values as value, i}
			<div class="d-flex">
				<div class="p-2 flex-fill">
					<TextInputSub
						Required={i + 1 >= Config.MinEntries}
						Validator={Config.Validator}
						bind:this={inputComps[i]}
					/>
					<div class="multitext-spacer" />
				</div>
				<div class="d-flex align-items-center">
					{#if i >= Config.MinEntries}
						<button
							style="padding: -5px 10px;"
							on:click={removeInput.bind(null, i)}
							class="btn-close"
							aria-label="Close"
							type="button"
						/>
					{/if}
				</div>
			</div>
		{/each}
		{#if curEntries < Config.MaxEntries}
			<div class="d-flex">
				<div class="p-2">
					<button class="btn btn-primary" on:click|preventDefault={addInput}>
						<i class="fas fa-plus" />
					</button>
				</div>
			</div>
		{/if}
	</div>
</FormGroup>
